//訂單問答泡泡
import {AlertMessage} from "@plugins-fr/alertMessage";
import {orderQAPopup} from "@commons/userTracks/viewActionName";
import {recordUserViewTrack} from "@commons/userTracks/userTrack";

let JS_VARS = JSON.parse(shops);
if (JS_VARS.canUsedQA) {
    $(function () {
        $('.js_btn_ordersQa').on('click touchstart', function () {
            // var agent = $(this).data('agent'),
            let msg = $(this).data('msg');
            let status = $(this).data('status');
            if (status === 'hide') {
                $.get(JS_VARS.urls.getQaMsgAjax, {
                    order_no: JS_VARS.orders_no,
                    order_query_token: JS_VARS.orderQueryToken,
                }, function (result) {
                    if (result.status) {
                        if (result.view === '') {
                            $('.js_qa_record_ul').addClass('d-none');
                            $('.js_qa_record').addClass('d-none').removeClass('d-flex');
                            $('.js_qa_nodata').removeClass('d-none');
                        } else {
                            $('.js_qa_nodata').addClass('d-none');
                            $('.js_qa_record').removeClass('d-none').addClass('d-flex');
                            $('.js_qa_record_ul').html(result.view).removeClass('d-none');
                            setTimeout(function () {
                                $(".js_qa_record").parent().scrollTop(999999999999999);
                            }, 10);
                        }
                    } else {
                        new AlertMessage({
                            'title': result.message
                        }).handle();
                        return false;
                    }
                }, 'json');

                $('body, .js_contactus_content, .js_contactus_area, .js_msg_block').addClass("full_height");
                $('.js_btn_ordersQa').data('status', 'show');
                // $('.js_msg_block').click();
                $('.js_contactus_area').addClass('active');
                // $('.js_msg_block').addClass('d-none');
                $('.js_msg_block[data-comment="' + msg + '"]').removeClass('d-none');

                recordUserViewTrack(orderQAPopup, '', {
                    'order_no': JS_VARS.orders_no,
                });
            } else {
                $('body, .js_contactus_content, .js_contactus_area, .js_msg_block').removeClass("full_height");
                // var contactus_height = $('.js_contactus_area').height();
                $('.js_btn_ordersQa').data('status', 'hide');
                $('.js_contactus_area').removeClass('active');
                // $('.js_contactus_area').animate({'bottom': '-' + contactus_height + 'px'}, 400);
                // setTimeout(function () {
                //     $('.js_contactus_area').removeClass('active');
                // }, 400);

                // $('#contactus_trigger').prop('checked', false);
            }

            return false;
        });
// 有未讀訊息時，自動展開
        if (parseInt(JS_VARS.custom_unread_count) > 0) {
            $('.js_btn_ordersQa.js_btn_ordersQa_open').click();
        }

        // QA 送出
        $('#qa_button_submit').click(function(event){
            event.preventDefault();
            if ($(this).attr('disabled') === 'disabled') {
                return false;
            }
            const submitButtonDom = $('#qa_button_submit');
            const recordUl = $('.js_qa_record_ul');
            submitButtonDom.attr('disabled', 'disabled');

            let msg = $('#orders_qa_msg').val();

            if (msg === '') {
                $('#qa_button_submit').removeAttr('disabled');
                new AlertMessage({
                    'title': '請先輸入詢問內容'
                }).handle();
                return false;
            }

            $.post(JS_VARS.urls.saveQaMsgAjax, {
                // img: img,
                // path: path,
                msg: msg,
                order_no: JS_VARS.orders_no,
                order_query_token: JS_VARS.orderQueryToken,
            }, function(result){
                $('#qa_button_submit').removeAttr('disabled');
                if (result.status) {
                    $('.js_qa_nodata').addClass('d-none');
                    recordUl.removeClass('d-none');
                    recordUl.append(result.view).removeClass('d-none');
                    $('.js_qa_record').removeClass('d-none').addClass('d-flex');
                    $(".js_qa_record").parent().scrollTop(999999999999999);

                } else {
                    new AlertMessage({
                        'title': result.errormsg
                    }).handle();
                }

                $('#orders_qa_msg').val('');
            }, 'json');
        });

        function updateContactHeight()
        {
            let height = window.innerHeight;
            height -= $('.el_contact_topbar').innerHeight();
            height -= $('.el_contact_enter').innerHeight();
            $('.el_contact_wrap').css('max-height', height + 'px');
        }

        updateContactHeight();

        $(window).resize(function() {
            updateContactHeight();
        });
    });
}
